import unboundProcessValue from "./processValue";

export default function (item, data, formData, prefix = '', onlyPresent = false) {
    const bookableGroup = item.bookable_group;
    const processValue = unboundProcessValue.bind(this);
    const groupData = { bookable_group_id: bookableGroup?.id }
    if (bookableGroup?.type === 'cars') {
        groupData.bookable_objects = bookableGroup.bookable_objects.map((bookableObject) => {
            const data = { bookable_object_id: bookableObject.id }
            for (const subKey of ['reservation_id', 'start_date', 'start_time', 'end_date', 'end_time']) {
                const fieldKey = `${prefix}${bookableObject.form_mapping}.${subKey}`;
                const exists = document.querySelector(`[name="${fieldKey}"]`);
                if (onlyPresent && !exists) {
                    return;
                }
                const value = formData.get(fieldKey) || null;
                data[subKey] = processValue(
                    item,
                    value,
                    fieldKey
                )
            }
            return data;
        })
    }
    if (bookableGroup?.type === 'tickets') {
        for (const subKey of ['reservation_id', 'bookable_object_id']) {
            const fieldKey = `${prefix}${bookableGroup.form_mapping}.${subKey}`;
            const exists = document.querySelector(`[name="${fieldKey}"]`);
            if (onlyPresent && !exists) {
                return;
            }
            const value = formData.get(fieldKey) || null;
            groupData[subKey] = processValue(
                item,
                value,
                fieldKey
            )
        }
    }
    if (bookableGroup) {
        data['bookable_groups'] = { ...data['bookable_groups'], [bookableGroup.id]: groupData }
    }
}
